import { inject, injectable } from "inversify";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { ICPLClientPortalClientsClient } from "./api/cplapi/CPLAPI";

export interface IClientsService {
  getEmailMatchesClient(clientAccountNumber: string, emailAddress: string): Promise<string>;
}

@injectable()
export class ClientsService implements IClientsService {
  @inject(SERVICE_TYPES.CPLClientPortalClientsClient) cplClientPortalClientsClient!: ICPLClientPortalClientsClient;

  async getEmailMatchesClient(clientAccountNumber: string, emailAddress: string): Promise<string> {
    return await this.cplClientPortalClientsClient.getEmailMatchesClient(clientAccountNumber, emailAddress);
  }
}
